(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-gift-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initGiftGuide(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = [...root.querySelectorAll('[data-gift-card]')];
      const buttons = [...root.querySelectorAll('[data-budget]')];
      const interest = root.querySelector('[data-interest-filter]');
      const count = root.querySelector('[data-gift-count]');
      let budget = 'all';
      root.querySelector('.hc-gifts__filters').hidden = false;
      if (root.dataset.currency !== 'DKK') root.querySelector('.hc-gifts__budget').hidden = true;
      function filter() {
        let visible = 0;
        cards.forEach(card => {
          const price = Number(card.dataset.price) / 100;
          const limits = { '100':[0,100], '200':[100,200], '300':[200,300], '500':[300,500], '1000':[500,1000], '2000':[1000,2000] };
          const range = limits[budget];
          const within = budget === 'all' || (range && price <= range[1] && (range[0] === 0 ? price >= 0 : price > range[0]));
          const match = within && (interest.value === 'all' || card.dataset.interest === interest.value);
          card.hidden = !match;
          if (match) visible++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.budget === budget)));
        count.textContent = root.dataset.countLabel.replace('[count]', String(visible));
        root.querySelector('[data-empty]').hidden = visible > 0;
      }
      function fromHash() {
        const match = window.location.hash.match(/^#budget-(100|200|300|500|1000|2000|over)$/);
        if (match && root.dataset.currency === 'DKK') budget = match[1] === 'over' ? '2000' : match[1];
        else if (!window.location.hash) budget = 'all';
        filter();
        if (match) root.querySelector('#gavevalg').scrollIntoView({ block: 'start' });
      }
      buttons.forEach(button => button.addEventListener('click', () => {
        budget = button.dataset.budget;
        history.replaceState(null, '', budget === 'all' ? window.location.pathname + window.location.search : '#budget-' + budget);
        filter();
      }));
      interest.addEventListener('change', filter);
      root.querySelector('[data-reset]').addEventListener('click', () => {
        budget = 'all'; interest.value = 'all';
        history.replaceState(null, '', window.location.pathname + window.location.search);
        filter();
      });
      window.addEventListener('hashchange', fromHash);
      fromHash();
    }
    function initAll() { document.querySelectorAll('[data-gift-guide]').forEach(initGiftGuide); }
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
